import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ChevronIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 13 21"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 21)}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth={2}
      strokeLinecap="round"
      {...svgProps}
    >
      <path d="m1.9 19.8 9.2-9.3L2 1.2" />
    </SVG>
  );
};
